
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { BrandModel } from 'models/generated/Entities.GormCrm.Brand';


const _gormCrm_BrandControllerHelper = new Map<string, Object>();
_gormCrm_BrandControllerHelper.set('GetAllBrands', BrandModel);


export const gormCrm_BrandControllerHelper = _gormCrm_BrandControllerHelper;

